module.exports = __webpack_public_path__ + "static/logo-large-f4bdcf6fd1561d7f1b8b85024c931448.png";